import React, { useState, useEffect } from "react";
import {
  Modal,
  Select,
  DatePicker,
  Radio,
  InputNumber,
  TreeSelect,
} from "antd";
import moment from "moment";
const { TreeNode } = TreeSelect;
const { Option } = Select;

export const TransactionModal = ({
  title,
  open,
  handleCancel,
  handleChange,
  data,
  handleSave,
  categories,
  banks,
}) => {
  const [localData, setLocalData] = useState(data || {});

  useEffect(() => {
    setLocalData(data || {});
  }, [data, open]);

  const handleCategoryChange = (value, extra) => {
    const selectedNode = extra.triggerNode;
    const parentNode = selectedNode && selectedNode.props.label;
    const selectedCategory = parentNode ? `${value}-${parentNode}` : value;

    if (selectedCategory && selectedCategory.includes("-")) {
      const [subcategoryName, categoryName] = selectedCategory
        .split("-")
        .map((item) => item.trim());

      let categoryId = null;
      let subcategoryId = null;
      categories &&
        categories.forEach((category) => {
          if (category.categoryName === categoryName) {
            categoryId = category.id;
            const subcategory =
              category.subCategories &&
              category.subCategories.find(
                (sub) => sub.name === subcategoryName,
              );
            if (subcategory) {
              subcategoryId = subcategory.id;
            }
          }
        });

      setLocalData((prev) => ({
        ...prev,
        categoryName: subcategoryName,
        categoryFromPlaid: categoryName,
        categoryId: categoryId,
        subCategoryId: subcategoryId,
        subCategory: subcategoryName,
      }));
    } else {
      let categoryId = null;
      const matchedCategory =
        categories && categories.find((item) => item.categoryName === value);
      if (matchedCategory) {
        categoryId = matchedCategory.id;
      }
      setLocalData((prev) => ({
        ...prev,
        categoryName: value,
        categoryId: categoryId,
        subCategoryId: null,
        subCategory: null,
        categoryFromPlaid: value,
      }));
    }
  };

  const handleLocalChange = (name, value) => {
    if (
      name === "paidUsing" &&
      localData &&
      localData.paidUsing &&
      localData.paidUsing === value
    ) {
      setLocalData((prev) => {
        const newState = { ...prev };
        delete newState.paidUsing;
        return newState;
      });
    } else {
      setLocalData((prev) => ({ ...prev, [name]: value }));
    }
  };

  const tags = [
    "Me",
    "For Family",
    "For Child",
    "For Friends",
    "For Consultant",
  ];

  return (
    <div>
      <Modal
        visible={open}
        footer={null}
        onOk={handleCancel}
        onCancel={handleCancel}
        closable={false}
        centered
      >
        <div style={{ display: "flex", gap: "1rem", alignItems: "center" }}>
          <h3 className="modaltitle">{title}</h3>
          {title === "Edit Transaction" && localData && localData.bankName && (
            <div className="accountNumber"> {localData.bankName}</div>
          )}
          {title === "Edit Transaction" &&
            localData &&
            localData.accountNumber && (
              <div className="accountNumber">
                {"****" + localData.accountNumber}
              </div>
            )}
        </div>
        <div
          style={{
            marginTop: "1rem",
            maxHeight: "25rem",
            overflow: "scroll",
            padding: "1rem",
          }}
        >
          <div style={{ marginBottom: "8px" }}>
            <h3 className="inputTitle">
              Date <span style={{ color: "red" }}>*</span>
            </h3>
            <DatePicker
              style={{
                width: "100%",
                border: "1px solid #d1d5db",
                borderRadius: "5px",
              }}
              size="large"
              format={"MM/DD/YYYY"}
              placeholder="Date"
              name="date"
              value={localData && localData.date && moment.utc(localData.date)}
              id="newDate"
              onChange={(date, dateString) => {
                handleLocalChange("date", dateString);
              }}
            />
          </div>
          <div style={{ marginBottom: "8px" }}>
            <h3 className="inputTitle">
              Item Name <span style={{ color: "red" }}>*</span>
            </h3>
            <input
              className="roleInput"
              placeholder="Item Name"
              name="itemName"
              value={localData && localData.itemName}
              id="itemName"
              onChange={(e) => {
                e.preventDefault();
                handleLocalChange(e.target.name, e.target.value);
              }}
            />
          </div>
          <div style={{ marginBottom: "8px" }}>
            <h3 className="inputTitle">Description</h3>
            <input
              className="roleInput"
              placeholder="Description"
              name="description"
              value={localData && localData.description}
              id="amount"
              onChange={(e) => {
                e.preventDefault();
                handleLocalChange(e.target.name, e.target.value);
              }}
            />
          </div>
          <div style={{ marginBottom: "8px" }}>
            <h3 className="inputTitle">Bank Account</h3>
            <Select
              showSearch
              placeholder="-Select-"
              value={localData && localData.accountTitle}
              onChange={(value, id) => {
                handleLocalChange("accountTitle", value);
              }}
            >
              {banks &&
                banks.map((item, index) => (
                  <Option key={index} value={item.accountTitle}>
                    {item.accountTitle}
                  </Option>
                ))}
            </Select>
          </div>
          <div style={{ marginBottom: "8px" }}>
            <h3 className="inputTitle">Category</h3>
            <TreeSelect
              showSearch
              dropdownStyle={{ maxHeight: 400, overflow: "auto" }}
              placeholder="Choose Category"
              allowClear
              value={localData && localData.categoryName}
              onChange={(value, label, extra) => {
                handleCategoryChange(value, extra);
              }}
            >
              {categories &&
                categories.map((category) => {
                  let parentLabel = category.categoryName;
                  return (
                    <TreeNode
                      key={category.id}
                      value={category.categoryName}
                      title={category.categoryName}
                    >
                      {category.subCategories.map((subCategory, index) => (
                        <TreeNode
                          key={`${category.id}-${index}`}
                          value={subCategory.name}
                          title={subCategory.name}
                          label={parentLabel}
                        />
                      ))}
                    </TreeNode>
                  );
                })}
            </TreeSelect>
          </div>
          <div style={{ marginBottom: "8px" }}>
            <h3 className="inputTitle">
              Expense or Income <span style={{ color: "red" }}>*</span>
            </h3>
            <Radio.Group
              buttonStyle="solid"
              name="typeOfTransaction"
              value={localData && localData.typeOfTransaction}
              onChange={(e) => {
                handleLocalChange(e.target.name, e.target.value);
              }}
            >
              {["Expense", "Income"].map((value, vindex) => (
                <Radio.Button key={vindex} value={value}>
                  {value}
                </Radio.Button>
              ))}
            </Radio.Group>
          </div>
          <div style={{ marginBottom: "8px" }}>
            <h3 className="inputTitle">
              {localData &&
                (localData.typeOfTransaction === "Expense"
                  ? "Expense"
                  : localData.typeOfTransaction === "Income"
                    ? "Income"
                    : "")}{" "}
              Amount <span style={{ color: "red" }}>*</span>
            </h3>
            <div className="inputWrapper" style={{ display: "flex" }}>
              <span
                style={{
                  fontSize: "15px",
                  padding: "8px",
                  display: "flex",
                  alignItems: "center",
                  color: "rgba(0, 0, 0, 0.65)",
                  background: "#fafafa",
                  borderRadius: "4px",
                  border: "1px solid #d1d5db",
                }}
              >
                $
              </span>
              <InputNumber
                step={1}
                formatter={(value) =>
                  `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                }
                parser={(value) => value.replace(/\$\s?|(,*)/g, "")}
                className="Input"
                placeholder="Amount"
                name="amount"
                value={localData && localData.amount}
                id="amount"
                onChange={(value) => {
                  handleLocalChange("amount", value);
                }}
              />
            </div>
          </div>
          <div style={{ marginBottom: "8px" }}>
            <h3 className="inputTitle">Cash or Check</h3>
            <Radio.Group
              buttonStyle="solid"
              name="paidUsing"
              value={localData && localData.paidUsing}
              onChange={(e) => {
                handleLocalChange(e.target.name, e.target.value);
              }}
            >
              {["Cash", "Check"].map((value, vindex) => (
                <Radio.Button
                  key={vindex}
                  value={value}
                  onClick={() => {
                    handleLocalChange("paidUsing", value);
                  }}
                >
                  {value}
                </Radio.Button>
              ))}
            </Radio.Group>
          </div>

          <div style={{ marginBottom: "8px" }}>
            <h3 className="inputTitle">Notes</h3>
            <input
              className="roleInput"
              placeholder="Notes"
              name="notes"
              value={localData && localData.notes}
              id="note"
              onChange={(e) => {
                e.preventDefault();
                handleLocalChange(e.target.name, e.target.value);
              }}
            />
          </div>
        </div>
        <div className="buttonsMain">
          <button
            className="cancelbutton"
            onClick={() => {
              handleCancel();
            }}
          >
            Cancel
          </button>
          <button
            className="savebutton"
            disabled={
              !localData ||
              !localData.date ||
              !localData.itemName ||
              !localData.amount ||
              !localData.typeOfTransaction
            }
            onClick={() => {
              handleSave(localData);
            }}
          >
            Save
          </button>
        </div>
      </Modal>
    </div>
  );
};
